const rounded = value => {
  const num = Number(value)
  return Number.isNaN(num) ? '-' : num.toFixed(2).replace('.', ',')
}

export const TYPE_COLUMNS = [
  {
    field: 'name',
    headerName: 'Nome',
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'dailyIdeal',
    headerName: 'Diária ideal',
    width: 200,
    editable: false,
    renderCell: ({ value }) => (value != null ? `R$ ${rounded(value)}` : '-'),
  },
  {
    field: 'periodIdeal',
    headerName: 'Período ideal',
    width: 200,
    editable: false,
    renderCell: ({ value }) => (value != null ? `R$ ${rounded(value)}` : '-'),
  },
  {
    field: 'hourIdeal',
    headerName: 'Hora ideal',
    width: 200,
    editable: false,
    renderCell: ({ value }) => (value != null ? `R$ ${rounded(value)}` : '-'),
  },
  {
    field: 'dailyMax',
    headerName: 'Diária máximo',
    width: 200,
    editable: false,
    renderCell: ({ value }) => (value != null ? `R$ ${rounded(value)}` : '-'),
  },
  {
    field: 'periodMax',
    headerName: 'Período máximo',
    width: 200,
    editable: false,
    renderCell: ({ value }) => (value != null ? `R$ ${rounded(value)}` : '-'),
  },
  {
    field: 'hourMax',
    headerName: 'Hora máximo',
    width: 200,
    editable: false,
    renderCell: ({ value }) => (value != null ? `R$ ${rounded(value)}` : '-'),
  },
]

export const PAINTING_SLUG = 'painting'
